import { Injectable, Renderer2, RendererFactory2 } from '@angular/core';
import { DomSmallUtils } from 'sharedGuiSmall/utils/dom-utils';

declare var jQuery: JQueryStatic;

interface SetAreaLoadingOptions {
    areaEl: Element;
    loading: boolean;
    xOffset?: number;
    yOffset?: number;
    testId?: string;
    spinnerId?: string;
    zIndex?: number;
}

@Injectable({ providedIn: 'root' })
export class LoadingSpinnerService {

    public static rootElSelector = '.loadingio-spinner-rolling-vo35qopy25';

    private renderer: Renderer2;
    private loading: boolean = false;

    constructor(private rendererFactory: RendererFactory2) {
        this.renderer = this.rendererFactory.createRenderer(null, null);
    }

	public get isLoading(): boolean {
		return this.loading;
	}

    public setLoading(loading: boolean): void {
        loading ? this.showSpinner() : this.hideSpinner();
    }

	public showSpinner() {
        const loadDiv = <HTMLElement>document.querySelector(LoadingSpinnerService.rootElSelector);
        this.renderer.setStyle(loadDiv, 'opacity', 1);
        this.renderer.setStyle(loadDiv, 'zIndex', 2147483647);
        this.renderer.setStyle(loadDiv, 'display', '');
        this.loading = true;
	}

    public async hideSpinner(): Promise<void> {
        const loadDiv = <HTMLElement>document.querySelector(LoadingSpinnerService.rootElSelector);
        return new Promise<void>(resolve => {
            jQuery(loadDiv).fadeOut("slow", () => {
                this.renderer.setStyle(loadDiv, 'zIndex', 0);
                this.renderer.setStyle(loadDiv, 'display', 'none');
                this.loading = false;
                resolve();
            });
        });
    }

    public setAreaLoading(options: SetAreaLoadingOptions): void {

        const { areaEl, loading, xOffset, yOffset, testId, spinnerId, zIndex } = options;

        let areaElRect = areaEl?.getBoundingClientRect();
        if (loading && (!areaEl || areaElRect.width === 0 || areaElRect.height === 0)) return;

        const loadDivSelector = (spinnerId && spinnerId.length > 0) ? `[id="${spinnerId}"]` : '.loadingio-spinner-rolling-vo35qopy25';

        let loadDiv = <HTMLElement>DomSmallUtils.find(areaEl, loadDivSelector);

        if (loading) {

            const isFading = jQuery(loadDiv).is(":animated");

            if (loadDiv && (areaEl.className !== 'cnt-column filler') && !isFading)
                return;

            if (isFading)
                jQuery(loadDiv).finish();

            let style = `position: absolute;`
            if (zIndex)
                style += `z-index: ${zIndex};`;

            loadDiv = DomSmallUtils.generateElements(`
                <div class="loadingio-spinner-rolling-vo35qopy25"
                     id="${spinnerId}"
                     style="${style}">
                    <div class= "ldio-ty68crv3j7">
                        <div></div>
                    </div>
                </div>`);

            areaEl.setAttribute('data-testid', `${testId}LoadingSpinner`);
            areaEl.appendChild(loadDiv);

            const areaElOffset = DomSmallUtils.offset(areaEl as HTMLElement);
            DomSmallUtils.setOffset(loadDiv, { left: areaElOffset.left + (xOffset ? xOffset : 0), top: areaElOffset.top + (yOffset ? yOffset : 0) });
            areaElRect = areaEl.getBoundingClientRect();
            loadDiv.style.width = areaElRect.width + 'px';
            loadDiv.style.height = areaElRect.height + 'px';
        }
        else {
            if (loadDiv) {
                jQuery(loadDiv)?.fadeOut("slow", () => {
                    loadDiv.remove();
                });
            }
        }
    }

    public isAreaLoading(areaEl: Element): boolean {
        let loadDiv = jQuery(areaEl).find('.loadingio-spinner-rolling-vo35qopy25');
        if (loadDiv && loadDiv.length && !loadDiv.is(':animated')) return true;
        return false;
    }

    public getAreaLoadingDiv(areaEl: Element, areaName: string): HTMLElement {
        return <HTMLElement>DomSmallUtils.find(areaEl, areaName);
    }
}